import React from 'react';
     import '/vercel/path0/docs/guide/markdown.md?watch=parent';
export const demos = {
  'docs-guide-markdown-demo-0': {
    component: React.memo(React.lazy(async function() {
  /**
 * inline: true
 */ const { default: SourceCode } = await import('dumi/theme/builtins/SourceCode');
const content = `
:::code-group

\`\`\`bash [npm]
npm install -D dumi
\`\`\`

\`\`\`bash [yarn]
yarn add -D dumi
\`\`\`

\`\`\`bash [pnpm]
pnpm add -D dumi
\`\`\`

\`\`\`ts [.dumirc.ts] {3}
import { defineConfig } from 'dumi';

export default defineConfig({
  // ...
});
\`\`\`
:::
`.trim();
return {
    default: ()=>/*#__PURE__*/ React.createElement(SourceCode, {
            lang: "markdown"
        }, content)
};

})),
    asset: null,
    context: undefined,
    renderOpts: undefined,
  },
};